import React, { useRef } from 'react';
import styled from 'styled-components';
import { PaperBlurFitBtn } from './headless/button/BtnBody';
import { getBtnName } from '../constants/btnNames';
import { PreparedImageData } from '../util/imageUtils';

export interface ReplaceImageButtonForModalProps {
  setImageUrl: (originUrl: string, width: number, height: number) => void;
  prepareImage?: (file: File) => Promise<PreparedImageData>;
  accept?: string;
  isFileAccepted?: (file: File) => boolean;
  onInvalidFile?: () => void;
}

const ReplaceImageButtonForModal: React.FC<ReplaceImageButtonForModalProps> = ({
  setImageUrl,
  prepareImage,
  accept = 'image/*',
  isFileAccepted,
  onInvalidFile,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    if (isFileAccepted && !isFileAccepted(file)) {
      onInvalidFile?.();
      return;
    }

    if (prepareImage) {
      const preparedImage = await prepareImage(file);
      setImageUrl(preparedImage.originUrl, preparedImage.width, preparedImage.height);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const localImageUrl = reader.result as string;
      const img = new Image();
      img.onload = () => {
        setImageUrl(localImageUrl, img.width, img.height);
      };
      img.src = localImageUrl;
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <BtnWrapper>
        <PaperBlurFitBtn onClick={() => fileInputRef.current?.click()}>
          {getBtnName('REPLACE_IMAGE')}
        </PaperBlurFitBtn>
      </BtnWrapper>
      <HiddenFileInput
        type="file"
        ref={fileInputRef}
        onChange={handleImageChange}
        accept={accept}
      />
    </>
  );
};

const BtnWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

export default ReplaceImageButtonForModal;
